import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { wtApiCall } from '../../helpers/commons/ApiWrapper'
import ShareWithClient from './ShareWithClient'
import CorrectDeal, { CorrectionNotice } from './CorrectDeal'
import AgentContact, { AgentsInterested } from './AgentContact'
import { APP_BASE_URL } from '../../config/Request'
import Loading from 'src/helpers/commons/loader'
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage'
import RequestChangesModal from '../PendingProperties/RequestChangesModal'
import { AreaRequestBox } from '../Properties/Form'
import './PhotoSwipe.css'

const GREEN = '#1F4D3A'
const GOLD = '#CF9A41'

// ---------- small helpers ----------
const toList = (v) => {
  if (!v) return []
  if (Array.isArray(v)) return v
  try {
    const p = JSON.parse(v)
    return Array.isArray(p) ? p : []
  } catch (e) {
    return []
  }
}
const personName = (u) => {
  if (!u) return ''
  if (typeof u === 'string') return u
  return u.name || [u.first_name, u.last_name].filter(Boolean).join(' ')
}
const fmtDate = (d) => {
  if (!d) return ''
  const x = new Date(d)
  if (isNaN(x)) return ''
  return x.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}
const fmtPrice = (p, cur) => {
  if (p === null || p === undefined || p === '') return ''
  const n = Number(p)
  return (cur || 'KES') + ' ' + (isNaN(n) ? p : n.toLocaleString())
}
const has = (v) => v !== null && v !== undefined && v !== '' && v !== 0 && v !== '0'
const imgUrl = (path) => (path ? APP_BASE_URL + path : '')

// ---------- styles ----------
const css = `
.kls-pv { max-width: 1200px; margin: 0 auto; color: #222; }
.kls-pv .pv-back { background: none; border: none; color: ${GREEN}; font-weight: 600; padding: 0; margin-bottom: 12px; cursor: pointer; }
.kls-pv .pv-banner { border-radius: 10px; padding: 12px 16px; margin-bottom: 16px; font-size: 14px; }
.kls-pv .pv-banner.red { background: #fdecec; border: 1px solid #f3b4b4; color: #8a1f1f; }
.kls-pv .pv-banner.gold { background: #fbf4e8; border: 1px solid #ecd3a6; color: #6b4b12; }
.kls-pv .pv-top { display: grid; grid-template-columns: 3fr 2fr; gap: 20px; margin-bottom: 20px; }
.kls-pv .pv-main { width: 100%; max-width: 100%; height: 420px; object-fit: cover; border-radius: 12px; background: #eee; display: block; }
.kls-pv .pv-noimg { width: 100%; aspect-ratio: 4 / 3; border-radius: 12px; background: #eee; display: flex; align-items: center; justify-content: center; color: #888; }
.kls-pv .pv-thumbs { display: flex; gap: 8px; margin-top: 10px; overflow-x: auto; padding-bottom: 4px; }
.kls-pv .pv-thumb { width: 84px; height: 64px; object-fit: cover; border-radius: 8px; cursor: pointer; border: 3px solid transparent; flex: 0 0 auto; }
.kls-pv .pv-thumb.active { border-color: ${GOLD}; }
.kls-pv .pv-card { background: #fff; border-radius: 12px; box-shadow: 0 2px 8px rgba(0,0,0,.08); padding: 18px 20px; margin-bottom: 16px; }
.kls-pv .pv-card h5 { color: ${GREEN}; font-weight: 700; font-size: 16px; margin: 0 0 12px 0; padding-bottom: 8px; border-bottom: 2px solid ${GOLD}; display: inline-block; }
.kls-pv .pv-ref { color: ${GOLD}; font-weight: 700; letter-spacing: .5px; font-size: 14px; }
.kls-pv .pv-name { font-size: 22px; font-weight: 700; color: ${GREEN}; margin: 4px 0 10px; line-height: 1.25; }
.kls-pv .pv-badges { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 12px; }
.kls-pv .pv-badge { font-size: 12px; font-weight: 600; padding: 4px 10px; border-radius: 20px; }
.kls-pv .pv-badge.green { background: ${GREEN}; color: #fff; }
.kls-pv .pv-badge.ok { background: #e3f3ea; color: #1b6b3f; }
.kls-pv .pv-badge.wait { background: #fff4dc; color: #8a6200; }
.kls-pv .pv-badge.bad { background: #fdecec; color: #a12626; }
.kls-pv .pv-typeline { display: flex; justify-content: space-between; align-items: center; margin: 8px 0 12px; }
.kls-pv .pv-type { font-size: 15px; font-weight: 700; color: ${GREEN}; }
.kls-pv .pv-label { font-size: 11px; color: #777; text-transform: uppercase; letter-spacing: .4px; margin-bottom: 4px; }
.kls-pv .pv-short { color: #444; margin-bottom: 14px; padding-bottom: 12px; border-bottom: 1px solid #eee; }
.kls-pv .pv-price { font-size: 26px; font-weight: 800; color: ${GREEN}; margin-bottom: 14px; }
.kls-pv .pv-facts { display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px; margin-bottom: 14px; }
.kls-pv .pv-fact { background: #f5f7f6; border-radius: 8px; padding: 8px 10px; }
.kls-pv .pv-fact .l { font-size: 11px; color: #777; text-transform: uppercase; letter-spacing: .4px; }
.kls-pv .pv-fact .v { font-size: 15px; font-weight: 700; color: #222; }
.kls-pv .pv-poster { font-size: 13px; color: #555; border-top: 1px solid #eee; padding-top: 10px; }
.kls-pv .pv-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px 20px; }
.kls-pv .pv-row .l { font-size: 12px; color: #777; }
.kls-pv .pv-row .v { font-size: 15px; font-weight: 600; }
.kls-pv .pv-chips { display: flex; flex-wrap: wrap; gap: 8px; }
.kls-pv .pv-chip { background: #eef4f1; color: ${GREEN}; border: 1px solid #cfe0d7; border-radius: 20px; padding: 5px 12px; font-size: 13px; font-weight: 600; }
.kls-pv .pv-text { font-size: 15px; line-height: 1.6; }
.kls-pv .pv-text p:last-child { margin-bottom: 0; }
.kls-pv .pv-two { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
@media (max-width: 900px) {
  .kls-pv .pv-top, .kls-pv .pv-two { grid-template-columns: 1fr; }
  .kls-pv .pv-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 480px) {
  .kls-pv .pv-grid { grid-template-columns: 1fr; }
  .kls-pv .pv-name { font-size: 19px; }
  .kls-pv .pv-price { font-size: 22px; }
}
`

// Number box that shows commas while typing (12,500,000) but keeps plain digits
function MoneyInput({ value, onChange }) {
  const show =
    value === '' || value === null || value === undefined
      ? ''
      : Number(value).toLocaleString('en-US')
  return (
    <input
      type="text"
      inputMode="numeric"
      value={show}
      onChange={(e) => onChange(e.target.value.replace(/[^0-9]/g, '').slice(0, 13))}
    />
  )
}

function Row({ label, value }) {
  if (!has(value)) return null
  return (
    <div className="pv-row">
      <div className="l">{label}</div>
      <div className="v">{value}</div>
    </div>
  )
}

// ---------- Listing status card (owner / Super Admin / Manager) ----------
const lsCss = `
.kls-pv .ls-text { font-size: 14px; color: #444; margin-bottom: 4px; }
.kls-pv .ls-note { border-radius: 8px; padding: 10px 12px; font-size: 14px; margin-bottom: 8px; }
.kls-pv .ls-note.gold { background: #fbf4e8; border: 1px solid #ecd3a6; color: #6b4b12; }
.kls-pv .ls-note.red { background: #fdecec; border: 1px solid #f3b4b4; color: #8a1f1f; }
.kls-pv .ls-note.ok { background: #e3f3ea; border: 1px solid #b9dfc8; color: #1b6b3f; }
.kls-pv .ls-btns { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; }
.kls-pv .ls-btn { border: none; border-radius: 8px; padding: 9px 16px; font-weight: 600; font-size: 14px; cursor: pointer; }
.kls-pv .ls-btn:disabled { opacity: .6; cursor: default; }
.kls-pv .ls-btn.gold { background: ${GOLD}; color: #fff; }
.kls-pv .ls-btn.green { background: ${GREEN}; color: #fff; }
.kls-pv .ls-btn.light { background: #eef4f1; color: ${GREEN}; border: 1px solid #cfe0d7; }
.kls-pv .ls-form { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 12px; }
.kls-pv .ls-form label { font-size: 12px; color: #777; display: block; margin-bottom: 4px; }
.kls-pv .ls-form input { width: 100%; border: 1px solid #ccd; border-radius: 8px; padding: 8px 10px; font-size: 14px; }
.kls-pv .ls-hint { font-size: 12px; color: #888; margin-top: 6px; }
.kls-pv .ls-label2 { font-size: 13px; font-weight: 700; color: ${GREEN}; margin: 12px 0 6px; }
.kls-pv .ls-radios { display: flex; flex-wrap: wrap; gap: 8px; }
.kls-pv .ls-radio { display: flex; align-items: center; gap: 6px; border: 1px solid #cfe0d7; background: #fff; border-radius: 20px; padding: 7px 14px; font-size: 14px; cursor: pointer; margin: 0; }
.kls-pv .ls-radio.on { background: ${GREEN}; color: #fff; border-color: ${GREEN}; }
.kls-pv .ls-radio input { display: none; }
.kls-pv .ls-form.one { grid-template-columns: 1fr; }
.kls-pv .ls-form select { width: 100%; border: 1px solid #ccd; border-radius: 8px; padding: 8px 10px; font-size: 14px; background: #fff; }
.kls-pv .ls-lock { background: #f5f7f6; border-radius: 8px; padding: 10px 12px; margin-top: 10px; }
.kls-pv .ls-results { border: 1px solid #cfe0d7; border-radius: 8px; margin-top: 6px; max-height: 260px; overflow-y: auto; background: #fff; }
.kls-pv .ls-result { padding: 10px 12px; font-size: 14px; cursor: pointer; border-bottom: 1px solid #eef2f0; }
.kls-pv .ls-result:last-child { border-bottom: none; }
.kls-pv .ls-result:hover { background: #eef4f1; }
.kls-pv .ls-picked { display: flex; justify-content: space-between; align-items: center; background: #eef4f1; border: 1px solid #cfe0d7; border-radius: 8px; padding: 9px 12px; font-weight: 600; color: ${GREEN}; }
.kls-pv .ls-link { background: none; border: none; color: ${GOLD}; font-weight: 700; cursor: pointer; padding: 0; }
@media (max-width: 480px) {
  .kls-pv .ls-form { grid-template-columns: 1fr; }
  .kls-pv .ls-btn { flex: 1 1 100%; }
}
`
const hoursSince = (d) => (Date.now() - new Date(d).getTime()) / 3600000
const addDays = (d, n) => {
  const x = new Date(d)
  x.setDate(x.getDate() + n)
  return x
}

function ListingStatus({ id, p, canManage, reload, myClient }) {
  const [busy, setBusy] = useState(false)
  const [showDeal, setShowDeal] = useState(false)
  const [dealPrice, setDealPrice] = useState('')
  const [dealDate, setDealDate] = useState('')
  const [dealSource, setDealSource] = useState('')
  const [partnerId, setPartnerId] = useState('')
  const [commission, setCommission] = useState('')
  const [agents, setAgents] = useState(null)
  const [agentSearch, setAgentSearch] = useState('')
  const [clientId, setClientId] = useState('')
  const [clients, setClients] = useState(null)
  const [clientSearch, setClientSearch] = useState('')
  const me = wtGetFromLocalStorage('authUser') || {}

  useEffect(() => {
    if (dealSource !== 'kls' || agents !== null) return
    wtApiCall(
       'deal-agents?property_id=' + id,
      {},
      'get',
      (res) => setAgents(Array.isArray(res?.data) ? res.data : []),
      () => setAgents([]),
    )
  }, [dealSource])

  useEffect(() => {
    if (dealSource !== 'own' || clients !== null || me.isAdmin) return
    wtApiCall(
      'deal-clients',
      {},
      'get',
      (res) => setClients(Array.isArray(res?.data) ? res.data : []),
      () => setClients([]),
    )
  }, [dealSource])

  if (!canManage) return null

  const approved = Number(p.approval_status) === 1
  if (!approved) {
    if (p.is_relisting && Number(p.approval_status) === 0) {
      return (
        <div className="pv-banner gold">
          <b>Re-listing:</b> waiting for KLS back office to approve it again.
        </div>
      )
    }
    return null
  }

  const isRent = p.status === 'For Rent' || p.status === 'Rented'
  const word = isRent ? 'rented' : 'sold'
  const stage = Number(p.stale_stage || 0)
  const live = p.status === 'For Sale' || p.status === 'For Rent'
  const isDeal = p.status === 'Sold' || p.status === 'Rented'
  const hideDays = isRent ? 60 : 90

  const act = (path, body, confirmText, after) => {
    if (confirmText && !window.confirm(confirmText)) return
    setBusy(true)
    wtApiCall(
      'property/' + id + '/' + path,
      body || {},
      'post',
      (res) => {
        setBusy(false)
          setShowDeal(false)
        alert(res?.message || 'Done')
        if (after) after()
        reload()
      },
      (err) => {
        setBusy(false)
        alert(err?.message || 'Something went wrong')
        reload()
      },
    )
  }

  const markDeal = () => {
    if (!dealSource) return alert(`Please choose who introduced the ${isRent ? 'tenant' : 'buyer'}.`)
    if (dealSource === 'kls' && !partnerId) return alert('Please select the KLS agent who introduced the client.')
    const linked = dealSource === 'own' && clientId
      ? (clients || []).find((c) => String(c.value) === String(clientId))
      : null
    act(
      'mark-deal',
      {
        deal_source: dealSource,
        deal_partner_id: dealSource === 'kls' ? partnerId : '',
        deal_client_id: linked ? clientId : '',
        deal_price: dealPrice,
        deal_date: dealDate,
        deal_commission: me.isAdmin ? '' : commission,
      },
      `Mark this property as ${word}? Other agents will stop seeing it.`,
      linked && !linked.closed
        ? () => {
            if (window.confirm(`Mark ${linked.label} as Closed?\n\nOK = Close client\nCancel = Keep active`)) {
              wtApiCall('clients/' + clientId + '/status', { client_status: 'closed' }, 'post', () => {}, () => {})
            }
          }
        : null,
    )
  }

  let body = null

  if (live && stage < 3) {
    body = (
      <>
        {stage === 0 && (
          <div className="ls-note ok">
            Live. Last confirmed {fmtDate(p.confirmed_at) || 'on approval'}.
          </div>
        )}
        {stage === 1 && (
          <div className="ls-note gold">
            <b>Still available?</b> Other agents now see a "Not updated" tag on this listing.
          </div>
        )}
        {stage === 2 && (
          <div className="ls-note red">
            <b>Final notice:</b> this listing will be paused on{' '}
            {fmtDate(addDays(p.confirmed_at, hideDays))} unless you confirm it is still available.
          </div>
        )}

        {!showDeal ? (
          <div className="ls-btns">
            <button className="ls-btn green" disabled={busy} onClick={() => act('still-available')}>
              ✓ Still available
            </button>
            <button className="ls-btn gold" disabled={busy} onClick={() => setShowDeal(true)}>
              Mark {word}
            </button>
          </div>
        ) : (
          <>
                      <div className="ls-label2">Who introduced the {isRent ? 'tenant' : 'buyer'}?</div>
            <div className="ls-radios">
              {[
                ['own', 'My own client'],
                ['kls', 'Another KLS agent'],
                ['outside', 'Outside KLS'],
              ].map(([v, l]) => (
                <label key={v} className={'ls-radio' + (dealSource === v ? ' on' : '')}>
                  <input
                    type="radio"
                    name="deal_source"
                    checked={dealSource === v}
                    onChange={() => setDealSource(v)}
                  />
                  {l}
                </label>
              ))}
            </div>

            {dealSource === 'kls' && (
              <div className="ls-form one">
                <div>
                  <label>KLS agent</label>
                                   {agents === null ? (
                    <div className="ls-hint">Loading agents…</div>
                  ) : partnerId ? (
                    <div className="ls-picked">
                      <span>
                        {(agents.find((a) => String(a.value) === String(partnerId)) || {}).label}
                      </span>
                      <button
                        type="button"
                        className="ls-link"
                        onClick={() => {
                          setPartnerId('')
                          setAgentSearch('')
                        }}
                      >
                        Change
                      </button>
                    </div>
                  ) : (
                    <>
                      <input
                        type="text"
                        placeholder="Type the agent's name…"
                        value={agentSearch}
                        onChange={(e) => setAgentSearch(e.target.value)}
                        autoFocus
                      />
                      {agentSearch.trim().length > 0 &&
                        (() => {
                          const q = agentSearch.trim().toLowerCase()
                          const hits = agents
                            .filter((a) => (a.label || '').toLowerCase().includes(q))
                            .slice(0, 8)
                          return (
                            <div className="ls-results">
                              {hits.length === 0 ? (
                                <div className="ls-result" style={{ cursor: 'default', color: '#888' }}>
                                  No agent found
                                </div>
                              ) : (
                                hits.map((a) => (
                                  <div
                                    key={a.value}
                                    className="ls-result"
                                    onClick={() => setPartnerId(a.value)}
                                  >
                                    {a.label}
                                  </div>
                                ))
                              )}
                            </div>
                          )
                        })()}
                    </>
                  )}
                  <div className="ls-hint">
                    They will be asked to confirm. The deal counts for both of you once they do.
                  </div>
                </div>
              </div>
            )}

                        {dealSource === 'own' && !me.isAdmin && (
              <div className="ls-form one">
                <div>
                  <label>Which client? (optional)</label>
                  {clients === null ? (
                    <div className="ls-hint">Loading your clients…</div>
                  ) : clientId ? (
                    <div className="ls-picked">
                      <span>
                        {(clients.find((c) => String(c.value) === String(clientId)) || {}).label}
                      </span>
                      <button
                        type="button"
                        className="ls-link"
                        onClick={() => {
                          setClientId('')
                          setClientSearch('')
                        }}
                      >
                        Change
                      </button>
                    </div>
                  ) : clients.length === 0 ? (
                    <div className="ls-hint">You have no saved clients yet. You can skip this.</div>
                  ) : (
                    <>
                      <input
                        type="text"
                        placeholder="Type the client's name or phone…"
                        value={clientSearch}
                        onChange={(e) => setClientSearch(e.target.value)}
                      />
                      {clientSearch.trim().length > 0 &&
                        (() => {
                          const q = clientSearch.trim().toLowerCase()
                          const hits = clients
                            .filter(
                              (c) =>
                                (c.label || '').toLowerCase().includes(q) ||
                                (c.phone || '').toLowerCase().includes(q),
                            )
                            .slice(0, 8)
                          return (
                            <div className="ls-results">
                              {hits.length === 0 ? (
                                <div className="ls-result" style={{ cursor: 'default', color: '#888' }}>
                                  No client found
                                </div>
                              ) : (
                                hits.map((c) => (
                                  <div key={c.value} className="ls-result" onClick={() => setClientId(c.value)}>
                                    {c.label}
                                    <span style={{ color: '#888', fontSize: 12 }}>
                                      {' '}· {c.phone}
                                      {c.closed ? ' · Closed' : ''}
                                    </span>
                                  </div>
                                ))
                              )}
                            </div>
                          )
                        })()}
                    </>
                  )}
                  <div className="ls-hint">🔒 Only you can see which client this was.</div>
                </div>
              </div>
            )}

            <div className="ls-form">
              <div>
                <label>Final price ({p.currency || 'KES'})</label>
               <MoneyInput value={dealPrice} onChange={setDealPrice} />
              </div>
              <div>
                <label>Date {word}</label>
                <input type="date" value={dealDate} onChange={(e) => setDealDate(e.target.value)} />
              </div>
            </div>
            <div className="ls-hint">
              Add the final price so this deal counts toward your monthly total and personal best.
              Only shared agent (if applicable) will see it.
          
            </div>

            {!me.isAdmin && (
              <div className="ls-lock">
                <div className="ls-form one" style={{ marginTop: 0 }}>
                  <div>
                    <label>🔒 Your commission ({p.currency || 'KES'}) — only you can see this</label>
                     <MoneyInput value={commission} onChange={setCommission} />
                  </div>
                </div>
              </div>
            )}

            <div className="ls-btns">
              <button className="ls-btn gold" disabled={busy} onClick={markDeal}>
                Confirm {word}
              </button>
              <button className="ls-btn light" disabled={busy} onClick={() => setShowDeal(false)}>
                Cancel
              </button>
            </div>
          </>
        )}
      </>
    )
  } else if (live && stage === 3) {
    body = (
      <>
        <div className="ls-note red">
          <b>{p.hidden_by_kls_at ? 'Hidden by KLS' : 'Paused'}</b>
          {fmtDate(p.stale_hidden_at) ? ` since ${fmtDate(p.stale_hidden_at)}` : ''}. Other agents
          can no longer see it. Review the details, then resubmit for approval.
        </div>
        {p.hidden_reason && (
          <div className="ls-text">
            <b>Reason from KLS:</b> {p.hidden_reason}
          </div>
        )}
        <div className="ls-btns">
          <button
            className="ls-btn gold"
            disabled={busy}
            onClick={() => act('relist', {}, 'Resubmit this listing to KLS for approval?')}
          >
            Resubmit for approval
          </button>
        </div>
      </>
    )
  } else if (isDeal) {
    const hrs = p.deal_marked_at ? hoursSince(p.deal_marked_at) : 99999
    body = (
      <>
        <div className="ls-note ok">
          <b>Marked {p.status}</b>
          {fmtDate(p.deal_marked_at) ? ` on ${fmtDate(p.deal_marked_at)}` : ''}.
          {p.deal_price ? ` Final price: ${fmtPrice(p.deal_price, p.currency)}.` : ''}
          {p.deal_date ? ` Date ${word}: ${fmtDate(p.deal_date)}.` : ''}
        </div>
        {p.deal_source && (
          <div className="ls-text">
            Introduced by:{' '}
            <b>
              {p.deal_source === 'own'
                ? 'Your own client'
                : p.deal_source === 'outside'
                ? 'Outside KLS'
                : personName(p.deal_partner) || 'Another KLS agent'}
            </b>
            {p.deal_source === 'kls' &&
              (p.deal_partner_status === 'confirmed'
                ? ' · ✓ confirmed'
                : p.deal_partner_status === 'declined'
                ? ' · said "Not me"'
                : ' · waiting for them to confirm')}
          </div>
        )}
        {myClient && (
          <div className="ls-text">🔒 Your client: <b>{myClient.name}</b></div>
        )}
        {!me.isAdmin && has(p.deal_commission) && (
          <div className="ls-text">🔒 Your commission: {fmtPrice(p.deal_commission, p.currency)}</div>
        )}
        <div className="ls-btns">
          {hrs < 24 && (
            <button
              className="ls-btn light"
              disabled={busy}
              onClick={() => act('reopen', {}, 'Undo? The deal will not be counted.')}
            >
              ↶ Undo
            </button>
          )}
          {hrs >= 24 && hrs < 30 * 24 && (
            <button
              className="ls-btn green"
              disabled={busy}
              onClick={() =>
                act('reopen', {}, 'Put this listing back on the market? The deal will be removed from your count.')
              }
            >
              Available again
            </button>
          )}
          {hrs >= 30 * 24 && (
            <button
              className="ls-btn gold"
              disabled={busy}
              onClick={() => act('relist', {}, 'Resubmit this listing to KLS for approval?')}
            >
              Resubmit for approval
            </button>
          )}
        </div>
        {hrs < 24 && <div className="ls-hint">Undo is available for 24 hours.</div>}
      </>
    )
  }

  if (!body) return null

  return (
    <div className="pv-card">
      <style>{lsCss}</style>
      <h5>Listing status</h5>
      {body}
    </div>
  )
}

// ---------- Pick one of my own clients (private) ----------
function ClientPicker({ clients, clientId, setClientId }) {
  const [search, setSearch] = useState('')

  if (clients === null) return <div className="ls-hint">Loading your clients…</div>
  if (clients.length === 0) return <div className="ls-hint">You have no saved clients yet. You can skip this.</div>

  if (clientId) {
    return (
      <div className="ls-picked">
        <span>{(clients.find((c) => String(c.value) === String(clientId)) || {}).label}</span>
        <button
          type="button"
          className="ls-link"
          onClick={() => {
            setClientId('')
            setSearch('')
          }}
        >
          Change
        </button>
      </div>
    )
  }

  const q = search.trim().toLowerCase()
  const hits = q
    ? clients
        .filter((c) => (c.label || '').toLowerCase().includes(q) || (c.phone || '').toLowerCase().includes(q))
        .slice(0, 8)
    : []

  return (
    <>
      <input
        type="text"
        placeholder="Type the client's name or phone…"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      {q && (
        <div className="ls-results">
          {hits.length === 0 ? (
            <div className="ls-result" style={{ cursor: 'default', color: '#888' }}>
              No client found
            </div>
          ) : (
            hits.map((c) => (
              <div key={c.value} className="ls-result" onClick={() => setClientId(c.value)}>
                {c.label}
                <span style={{ color: '#888', fontSize: 12 }}>
                  {' '}· {c.phone}
                  {c.closed ? ' · Closed' : ''}
                </span>
              </div>
            ))
          )}
        </div>
      )}
    </>
  )
}

// ---------- Partner agent: confirm or "Not me" ----------
function PartnerDeal({ id, p, reload, myClient }) {
  const [busy, setBusy] = useState(false)
  const [commission, setCommission] = useState('')
  const [clientId, setClientId] = useState('')
  const [clients, setClients] = useState(null)
  const isRent = p.status === 'Rented'
  const word = isRent ? 'rented' : 'sold'
  const who = isRent ? 'tenant' : 'buyer'
  const st = p.deal_partner_status
  const poster = p.agent_name || 'The posting agent'

  useEffect(() => {
    if (st !== 'waiting' || clients !== null) return
    wtApiCall(
      'deal-clients',
      {},
      'get',
      (res) => setClients(Array.isArray(res?.data) ? res.data : []),
      () => setClients([]),
    )
  }, [st])

  const send = (action) => {
    if (action === 'decline' && !window.confirm('Tell KLS this was not your deal?')) return
    const linked =
      action === 'confirm' && clientId
        ? (clients || []).find((c) => String(c.value) === String(clientId))
        : null
    setBusy(true)
    wtApiCall(
      'property/' + id + '/deal-partner',
      {
        action,
        commission: action === 'confirm' ? commission : '',
        client_id: linked ? clientId : '',
      },
      'post',
      (res) => {
        setBusy(false)
        alert(res?.message || 'Done')
        if (linked && !linked.closed &&
          window.confirm(`Mark ${linked.label} as Closed?\n\nOK = Close client\nCancel = Keep active`)) {
          wtApiCall('clients/' + clientId + '/status', { client_status: 'closed' }, 'post', () => {}, () => {})
        }
        reload()
      },
      (err) => {
        setBusy(false)
        alert(err?.message || 'Something went wrong')
      },
    )
  }

  let body = null
  if (st === 'waiting') {
    body = (
      <>
        <div className="ls-note gold">
          <b>{poster}</b> marked this property {word} and has named you as the agent who introduced the {who}.
          {p.deal_price ? ` Final price: ${fmtPrice(p.deal_price, p.currency)}.` : ''}
        </div>
        <div className="ls-form one">
          <div>
            <label>Which client? (optional)</label>
            <ClientPicker clients={clients} clientId={clientId} setClientId={setClientId} />
            <div className="ls-hint">🔒 Only you can see which client this was.</div>
          </div>
        </div>
        <div className="ls-lock">
          <div className="ls-form one" style={{ marginTop: 0 }}>
            <div>
              <label>🔒 Your commission ({p.currency || 'KES'}) — only you can see this</label>
              <MoneyInput value={commission} onChange={setCommission} />
            </div>
          </div>
        </div>
        <div className="ls-btns">
          <button className="ls-btn green" disabled={busy} onClick={() => send('confirm')}>
            ✓ Confirm, it was my client
          </button>
          <button className="ls-btn light" disabled={busy} onClick={() => send('decline')}>
            Not me
          </button>
        </div>
      </>
    )
  } else if (st === 'confirmed') {
    body = (
      <div className="ls-note ok">
        <b>You confirmed this deal.</b> It counts for you too.
        {p.deal_price ? ` Final price: ${fmtPrice(p.deal_price, p.currency)}.` : ''}
        {myClient ? ` 🔒 Your client: ${myClient.name}.` : ''}
        {has(p.deal_partner_commission)
          ? ` 🔒 Your commission: ${fmtPrice(p.deal_partner_commission, p.currency)}.`
          : ''}
      </div>
    )
  } else if (st === 'declined') {
    body = <div className="ls-note red">You said this was not your deal.</div>
  }

  if (!body) return null
  return (
    <div className="pv-card">
      <style>{lsCss}</style>
      <h5>Your deal</h5>
      {body}
    </div>
  )
}

// ---------- Review bar (Under review / Changes required) ----------
const rvCss = `
.rv-bar { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; background: #fff; border-left: 5px solid ${GOLD}; border-radius: 12px; box-shadow: 0 2px 8px rgba(0,0,0,.08); padding: 14px 18px; margin-bottom: 16px; }
.rv-bar.changes { border-left-color: #C0392B; }
.rv-status { font-weight: 700; color: ${GREEN}; font-size: 15px; }
.rv-bar.changes .rv-status { color: #C0392B; }
.rv-meta { color: #6b7280; font-size: 13px; margin-top: 2px; }
.rv-actions { display: flex; gap: 8px; flex-wrap: wrap; }
.rv-btn { border: none; border-radius: 8px; padding: 9px 16px; font-weight: 600; font-size: 14px; cursor: pointer; }
.rv-btn:disabled { opacity: .6; cursor: default; }
.rv-btn.approve { background: ${GREEN}; color: #fff; }
.rv-btn.changes { background: ${GOLD}; color: #fff; }
.rv-btn.edit { background: #fff; color: ${GREEN}; border: 1px solid ${GREEN}; }
.rv-btn.delete { background: #fff; color: #C0392B; border: 1px solid #C0392B; }
.rv-area { background: #FBF3E4; border: 1px solid ${GOLD}; color: #7a5a1e; border-radius: 10px; padding: 12px 16px; margin-bottom: 16px; font-size: 14px; }
@media (max-width: 768px) {
  .rv-bar { position: fixed; left: 0; right: 0; bottom: 0; margin: 0; border-radius: 14px 14px 0 0; border-left: none; border-top: 4px solid ${GOLD}; z-index: 1030; box-shadow: 0 -4px 16px rgba(0,0,0,.15); padding: 12px 16px; }
  .rv-bar.changes { border-top-color: #C0392B; }
  .rv-actions { width: 100%; }
  .rv-btn { flex: 1; padding: 11px 8px; }
  .rv-spacer { height: 150px; }
}
`

const rvPhoneCss = `
.rv-info{display:none}
@media (max-width: 767.98px){
  .rv-bar{position:fixed !important;left:0 !important;right:0 !important;bottom:0 !important;top:auto !important;z-index:1030;margin:0 !important;border-radius:0 !important;padding:8px 10px calc(8px + env(safe-area-inset-bottom)) !important;background:#fff !important;box-shadow:0 -2px 10px rgba(0,0,0,.12)}
  .rv-bar .rv-text{display:none !important}
  .rv-bar .rv-actions{display:flex !important;flex-wrap:nowrap;gap:6px;width:100%}
  .rv-bar .rv-btn{flex:1 1 auto;padding:9px 6px !important;font-size:12.5px !important;white-space:nowrap;min-width:0}
  .rv-info{display:block;margin:0 0 12px;padding:10px 12px;border-radius:10px;background:#eef4f0;border-left:4px solid #1F4D3A}
  .rv-info.changes{background:#fdeeee;border-left-color:#c0392b}
  .rv-info .rv-status{font-weight:600;color:#1F4D3A}
  .rv-info.changes .rv-status{color:#c0392b}
  .rv-info .rv-meta{font-size:13px;color:#555;margin-top:2px}
  .rv-spacer{display:none !important}
  body{padding-bottom:72px}
}
`

function HideListing({ id, p, reload }) {
  const [open, setOpen] = useState(false)
  const [reason, setReason] = useState('')
  const [busy, setBusy] = useState(false)
  const live = ['For Sale', 'For Rent'].includes(p.status) && !p.stale_hidden_at

  const box = (bg, border) => ({
    background: bg,
    border: '1px solid ' + border,
    borderRadius: 10,
    padding: '10px 14px',
    marginBottom: 14,
  })
  const btn = (bg, color, border) => ({
    padding: '7px 16px',
    borderRadius: 8,
    border: '1px solid ' + (border || bg),
    background: bg,
    color,
    fontWeight: 600,
    cursor: 'pointer',
  })

  if (p.hidden_by_kls_at) {
    return (
      <div style={box('#fdecec', '#d93737')}>
        <b>Hidden by KLS</b>
        {fmtDate(p.hidden_by_kls_at) ? ` since ${fmtDate(p.hidden_by_kls_at)}` : ''}. Other agents cannot see
        this listing until the agent resubmits it and it is approved.
        {p.hidden_reason && (
          <div style={{ marginTop: 4 }}>
            <b>Reason:</b> {p.hidden_reason}
          </div>
        )}
      </div>
    )
  }
  if (!live) return null

  const submit = () => {
    if (!reason.trim()) return alert('Please give a reason for hiding this listing.')
    if (!window.confirm(`Hide ${p.ref}? Other agents will no longer see it.`)) return
    setBusy(true)
    wtApiCall(
      'property/' + id + '/hide',
      { reason: reason.trim() },
      'post',
      () => {
        setBusy(false)
        setOpen(false)
        setReason('')
        reload()
      },
      (err) => {
        setBusy(false)
        alert(err?.message || 'Something went wrong')
      },
    )
  }

  return (
    <div style={box('#fff', '#e3e6e4')}>
      {!open ? (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <div>
            <b style={{ color: '#1F4D3A' }}>Active listing</b>
            <div className="small text-medium-emphasis">
              If something on this listing needs urgent attention, hide it and ask the agent to fix it.
            </div>
          </div>
          <button type="button" style={btn('#fff', '#d93737', '#d93737')} onClick={() => setOpen(true)}>
            Hide listing
          </button>
        </div>
      ) : (
        <>
          <div style={{ fontWeight: 700, color: '#1F4D3A', marginBottom: 6 }}>Hide listing</div>
          <div className="small mb-2">
            Other agents will no longer see this listing. The agent will see your reason, update the listing and
            resubmit it for approval.
          </div>
          <textarea
            className="form-control"
            rows={3}
            placeholder="Reason (shown to the agent)"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
          <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
            <button type="button" disabled={busy} style={btn('#d93737', '#fff')} onClick={submit}>
              {busy ? 'Hiding...' : 'Hide listing'}
            </button>
            <button
              type="button"
              disabled={busy}
              style={btn('#fff', '#1F4D3A', '#1F4D3A')}
              onClick={() => {
                setOpen(false)
                setReason('')
              }}
            >
              Cancel
            </button>
          </div>
        </>
      )}
    </div>
  )
}

function ReviewBar({ id, p, data, posterName, reload }) {
  const navigate = useNavigate()
  const [busy, setBusy] = useState(false)
  const [showChanges, setShowChanges] = useState(false)
  const me = wtGetFromLocalStorage('authUser') || {}
   const isBackOffice = !!me.isAdmin

  // Back office resolves a requested area here (no Edit needed). Find the town's ID by name, like the form does.
  const [townId, setTownId] = useState(null)
  const needTown = !!p.area_requested && isBackOffice
  useEffect(() => {
    if (!needTown) return
    wtApiCall(
      'locations/towns',
      {},
      'get',
      (res) => {
        const towns = res.data || []
        const c = (p.city_county || '').trim().toLowerCase()
        const hit =
          towns.find((t) => t.name.toLowerCase() === c && (!p.county || t.county === p.county)) ||
          towns.find((t) => t.name.toLowerCase() === c)
        setTownId(hit ? hit.id : 0)
      },
      () => setTownId(0),
    )
  }, [needTown, p.city_county, p.county])

  const st = Number(p.approval_status)
  if (st === 1) return isBackOffice ? <HideListing id={id} p={p} reload={reload} /> : null
  if (st !== 0 && st !== 2) return null
  const canReview = !!data.can_review
  const canEdit = !!data.can_edit_review
  const canDelete = !!data.can_delete_review
  const areaPending = !!p.area_requested

  const approve = () => {
    if (areaPending) return alert('Please resolve the requested area before approving.')
    if (!window.confirm(`Approve ${p.ref}? It will become visible to all KLS agents.`)) return
    setBusy(true)
    wtApiCall(
      'property/' + id,
      { action: 'approve' },
      'PUT',
      (res) => {
        setBusy(false)
        alert(typeof res?.data === 'string' ? res.data : res?.message || 'Listing approved.')
        navigate('/pending-properties')
      },
      (err) => {
        setBusy(false)
        alert(err?.message || 'Something went wrong')
      },
    )
  }

  const remove = () => {
    if (!window.confirm(`Delete ${p.ref}? This cannot be undone.`)) return
    setBusy(true)
    wtApiCall(
      'property/' + id,
      {},
      'DELETE',
      () => {
        setBusy(false)
        alert('Listing deleted.')
        navigate('/pending-properties')
      },
      (err) => {
        setBusy(false)
        alert(err?.message || 'Something went wrong')
      },
    )
  }

  const status =
    st === 0 ? (p.is_relisting ? 'Re-listing \u00b7 Under review' : 'Under review') : 'Changes required'
  const meta =
    st === 0
      ? isBackOffice
        ? `Submitted by ${posterName || 'agent'}${fmtDate(p.created_at) ? ' \u00b7 ' + fmtDate(p.created_at) : ''}`
        : 'KLS is reviewing your listing.'
      : isBackOffice
        ? 'Returned to agent \u00b7 waiting for changes'
        : 'KLS has requested changes. See the feedback below, then edit and resubmit.'

  return (
    <>
      <style>{rvCss + rvPhoneCss}</style>
           {(canReview || canEdit || canDelete) && (
        <div className={'rv-info' + (st === 2 ? ' changes' : '')}>
          <div className="rv-status">{status}</div>
          <div className="rv-meta">{meta}</div>
        </div>
      )}
      {(canReview || canEdit || canDelete) && (
        <div className={'rv-bar' + (st === 2 ? ' changes' : '')}>
          <div className="rv-text">
            <div className="rv-status">{status}</div>
            <div className="rv-meta">{meta}</div>
          </div>
          <div className="rv-actions">
            {canReview && st === 0 && (
              <>
                <button className="rv-btn approve" disabled={busy} onClick={approve}>Approve</button>
                <button className="rv-btn changes" disabled={busy} onClick={() => setShowChanges(true)}>Request changes</button>
              </>
            )}
            {canEdit && (
              <button className="rv-btn edit" disabled={busy} onClick={() => navigate('/pending-properties?edit=' + id)}>
                Edit
              </button>
            )}
            {canDelete && (
              <button className="rv-btn delete" disabled={busy} onClick={remove}>Delete</button>
            )}
          </div>
        </div>
      )}
      
      {areaPending && isBackOffice && townId !== null && (
        <AreaRequestBox
          propertyId={id}
          townId={townId}
          townName={p.city_county}
          requested={p.neighborhood_one}
        />
      )}
      {areaPending && !isBackOffice && (
        <div className="rv-area">
          <b>New area requested:</b> &ldquo;{p.neighborhood_one}&rdquo;
          {p.city_county ? ` in ${p.city_county}` : ''}. KLS will add it to the list or match it to an existing area
          during review.
        </div>
      )}



      {p.hidden_by_kls_at && (
        <div className="rv-area">
          <b>Previously hidden by KLS.</b> Reason: {p.hidden_reason || '-'}
        </div>
      )}
      <div className="rv-spacer" />
      {showChanges && (
        <RequestChangesModal
          id={id}
          refText={p.ref}
          onClose={() => setShowChanges(false)}
          onDone={() => {
            setShowChanges(false)
            reload()
          }}
        />
      )}
    </>
  )
}

export default function PropertyProfile() {
  const { id } = useParams()
  const params = useParams()
  const [data, setData] = useState(null)
  const [active, setActive] = useState('')
  const [slide, setSlide] = useState(0)
  const user = wtGetFromLocalStorage('authUser') || {}

   const load = () => {
    wtApiCall(
      'property/' + id,
      { token: params.token ? params.token : '' },
      'get',
      (response) => {
        setData(response.data)
        setActive((prev) => prev || response.data?.property?.featured_image || '')
      },
      (error) => {
        alert(error.message)
      },
    )
  }

  useEffect(() => {
    load()
  }, [id])

  if (data === null) return Loading

  const p = data.property || {}
  const gallery = (data.property_images || []).map((i) => i.property_image).filter(Boolean)
  const allPhotos = [p.featured_image, ...gallery].filter(Boolean)

  const isLand = (p.property_type || '').toLowerCase() === 'land'
  const features = toList(p.features)
  const bills = toList(p.bills)


  const approval = p.approval_status_name || ''
  

  const posterName =
    p.agent_name ||
    personName(p.created_by) ||
    personName(p.user) ||
    personName(p.agent) ||
    data.agent_name ||
    ''




 

  return (
    <div className="kls-pv">
      <style>{css}</style>

      <button className="pv-back" onClick={() => window.history.back()}>
        ← Back
      </button>

      {/* Banners */}
       <ReviewBar id={id} p={p} data={data} posterName={posterName} reload={load} />
      {approval === 'Rejected' && p.rejection_reason && (
        <div className="pv-banner red">
          <b>Not approved – changes required.</b> Feedback from KLS: {p.rejection_reason}
        </div>
      )}


      {/* Top: photos + summary */}
      <div className="pv-top">
        <div>
                  {allPhotos.length === 0 ? (
            <div className="pv-noimg">No image</div>
          ) : (
            <>
              {/* Phone: swipe carousel */}
              <div className="pv-swipe-wrap">
                <div
                  className="pv-swipe"
                  onScroll={(e) => {
                    const el = e.currentTarget
                    setSlide(Math.round(el.scrollLeft / el.clientWidth))
                  }}
                >
                  {allPhotos.map((ph, i) => (
                    <img key={i} src={imgUrl(ph)} alt="" className="pv-swipe-img" loading="lazy" />
                  ))}
                </div>
                {allPhotos.length > 1 && (
                  <div className="pv-swipe-count">
                    {slide + 1} / {allPhotos.length}
                  </div>
                )}
              </div>

              {/* Laptop: main photo + thumbnails (unchanged) */}
              <div className="pv-desk-photos">
                {active ? (
                  <img className="pv-main" src={imgUrl(active)} alt="Property" />
                ) : (
                  <div className="pv-noimg">No image</div>
                )}
                {allPhotos.length > 1 && (
                  <div className="pv-thumbs">
                    {allPhotos.map((ph, i) => (
                    <img loading="lazy"
                        key={i}
                        src={imgUrl(ph)}
                        alt=""
                        className={'pv-thumb' + (ph === active ? ' active' : '')}
                        onClick={() => setActive(ph)}
                      />
                    ))}
                  </div>
                )}
              </div>
            </>
          )}
        </div>

        <div className="pv-side-col">
        <div className="pv-card" style={{ marginBottom: 0 }}>
           {p.ref && <div className="pv-ref">{p.ref}</div>}
          <div className="pv-typeline">
             <span>
              {p.status && <span className="pv-badge green">{p.status}</span>}
              {(Number(p.stale_stage) === 1 || Number(p.stale_stage) === 2) && (
                <span className="pv-badge wait" style={{ marginLeft: 6 }}>Not updated</span>
              )}
            </span>
            {p.property_type && <span className="pv-type">{p.property_type}</span>}
          </div>
          <div className="pv-price">{fmtPrice(p.original_price, p.currency)}</div>
                    {p.short_description && (
            <>
              <div className="pv-label">Short description</div>
              <div
                className="pv-text pv-short"
                dangerouslySetInnerHTML={{ __html: p.short_description }}
              />
            </>
          )}
          {posterName && (
            <div className="pv-poster">
              Listed by <b>{posterName}</b>
              {fmtDate(p.created_at) ? ` · ${fmtDate(p.created_at)}` : ''}
            </div>
          )}
        </div>

        <div className="pv-card pv-work">
          <h5 className="pv-work-title">Listing Actions</h5>
          <div className="pv-work-body">
            <AgentContact id={id} />
            <CorrectionNotice p={p} />
            <ListingStatus id={id} p={p} canManage={data.can_manage_deal} reload={load} myClient={data.my_deal_client} />
            <CorrectDeal id={id} p={p} reload={load} />
            {data.is_deal_partner && <PartnerDeal id={id} p={p} reload={load} myClient={data.my_deal_client} />}
            <AgentsInterested id={id} />
            <ShareWithClient id={id} />
          </div>
        </div>
        </div>
      </div>
      {/* Basics + Nearby */}
      <div className="pv-two">
        <div className="pv-card">
          <h5>Basics</h5>
          <div className="pv-grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
            <Row label="Property type" value={p.property_type} />
            <Row label="Listing" value={p.status} />
            <Row label="Country" value={p.country} />
            <Row label="Town" value={p.city_county} />
            <Row label="Area" value={p.neighborhood_one} />
          </div>
        </div>

               {p.nearby && (
          <div className="pv-card">
            <h5>Nearby</h5>
            <div className="pv-text" style={{ whiteSpace: 'pre-line' }}>
              {p.nearby}
            </div>
          </div>
        )}
      </div>

      {/* Details */}
      <div className="pv-card">
        <h5>Details</h5>
        <div className="pv-grid">
          {isLand ? (
            <>
              <Row
                label="Plot size"
                value={has(p.plot_size) ? `${p.plot_size} ${p.plot_unit || ''}`.trim() : ''}
              />
              <Row label="Title deed ready" value={p.title_deed_ready ? 'Yes' : 'No'} />
            </>
          ) : (
            <>
              <Row label="Furnishing" value={p.furnishing} />
              <Row
                label="Bedrooms"
                value={p.bed_rooms !== null && p.bed_rooms !== '' && Number(p.bed_rooms) === 0 ? 'Studio' : p.bed_rooms}
              />
              <Row label="Bathrooms" value={p.rest_rooms} />
              <Row label="Parking spaces" value={p.parking_space} />
              <Row label="Size" value={has(p.sq_meter) ? `${p.sq_meter} m²` : ''} />
              <Row label="Year built" value={p.year_established} />
            </>
          )}
        </div>
      </div>

      {/* Features + Bills */}
      {(features.length > 0 || (!isLand && bills.length > 0)) && (
        <div className="pv-two">
          {features.length > 0 && (
            <div className="pv-card">
              <h5>Features</h5>
              <div className="pv-chips">
                {features.map((f) => (
                  <span className="pv-chip" key={f}>{f}</span>
                ))}
              </div>
            </div>
          )}
          {!isLand && bills.length > 0 && (
            <div className="pv-card">
              <h5>Bills the client pays</h5>
              <div className="pv-chips">
                {bills.map((b) => (
                  <span className="pv-chip" key={b}>{b}</span>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

          {/* Description */}
      {p.long_description && (
        <div className="pv-card">
          <h5>Description</h5>
          <div className="pv-text" dangerouslySetInnerHTML={{ __html: p.long_description }} />
        </div>
      )}

      {/* Disclosure */}
      {p.disclosure && (
        <div className="pv-card">
          <h5>Disclosure</h5>
          <div className="pv-text">{p.disclosure}</div>
        </div>
      )}
    </div>
  )
}